import { KeyedObject } from 'bernie-core/dist/source';
import * as React from 'react';
import { UitkHeading } from 'uitk-react-text';
import { ActivityDestinationViewSearch } from '../../../../../../common/__generated__/api';
import { ActivityFeature } from '../components/activity-feature';

export interface ActivitySpannedTileCardTitle {
  activity: ActivityDestinationViewSearch.ActivityInlineFragment;
  isInCarousel?: boolean;
  isVerticalLayout?: boolean;
  titleLines?: number;
}

export const ActivitySpannedTileCardTitle: React.FC<ActivitySpannedTileCardTitle> = ({
  activity,
  isInCarousel,
  isVerticalLayout,
  titleLines
}) => {
  const truncateClasses: KeyedObject = { 1: 'truncate', 2: 'truncate-lines-2', 3: 'truncate-lines-3' };
  const truncateClass = (titleLines && truncateClasses[titleLines]) || 'truncate';

  return (
    <section>
      {activity.features.enhancedCleaning && (
        <ActivityFeature
          label={activity.features.enhancedCleaning.label}
          icon={activity.features.enhancedCleaning.icon_temp}
          className="uitk-type-200 all-b-padding-one"
          data-testid="activity-enhanced-cleaning"
        />
      )}
      <UitkHeading
        tag="h3"
        size={5}
        className={`custom-wrap-text overflow-wrap uitk-type-heading-500 uitk-type-bold all-b-margin-two ${truncateClass} ${
          isInCarousel ? ' carouselTitleHeight' : ''
        }`}
        aria-hidden="true"
        data-testid="activity-spanned-tile-card--title"
      >
        {activity.name}
      </UitkHeading>
      {!isVerticalLayout && (
        <p
          className="grid-section-truncate truncate-lines-2 all-t-margin-zero all-b-margin-two uitk-type-200"
          data-testid="activity-spanned-tile-card--description"
        >
          {activity.description}
        </p>
      )}
    </section>
  );
};
